import script from "./DataImage.vue?vue&type=script&setup=true&lang=js"
export * from "./DataImage.vue?vue&type=script&setup=true&lang=js"

import "./DataImage.vue?vue&type=style&index=0&id=59d83f04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d83f04"]])

export default __exports__